"use client";

import { GoogleOneTap as GoogleOneTapOriginal } from "@clerk/nextjs";
export default function GoogleOneTap() {
  return <GoogleOneTapOriginal fedCmSupport={false} data-sentry-element="GoogleOneTapOriginal" data-sentry-component="GoogleOneTap" data-sentry-source-file="google-one-tap.tsx" />;
}